export const documentsPopupConstants = {
  DOCUMENTS_LIST_REQUESTING: "DOCUMENTS_LIST_REQUESTING",
  DOCUMENTS_LIST_FETCHED: "DOCUMENTS_LIST_FETCHED",
  DOCUMENTS_LIST_FAILED: "DOCUMENTS_LIST_FAILED",
  UPDATE_FULL_DOCUMENTS_POPUP_STATE: "UPDATE_FULL_DOCUMENTS_POPUP_STATE",
  SHOW_SANITY_POPUP:"SHOW_SANITY_POPUP",
  HIDE_SANITY_POPUP:"HIDE_SANITY_POPUP",
  PRIVATE_POPUP_CHAT_SOCKET:"PRIVATE_POPUP_CHAT_SOCKET"
};
